<template>
    <div class="container pt-4 mb-4" v-show="entitlementDetails && entitlementDetails.length != 0">
        <ConfirmationModal modalId="invalidEntitlement" triggerEventName="invalidEntitlement"/>
        <div v-show="entitlementDisplay">
            <h6 class="font-weight-bold" v-show="$route.path!=='/booking/history' ? true : false" v-html="entitlementTableHeader"></h6>
            <h6 class="font-weight-bold" v-show="$route.path==='/booking/history' ? true : false"> {{ TEXTS.render(`ENTITLEMENT_TABLE_HISTORY_HEADER`) }}</h6>
            <p v-html="TEXTS.render(`ENTITLEMENT_TABLE_PERIOD_HEADER`, null, {periodDate : periodDate})"></p>
            <div class="table-responsive">
                <table class="table border table-entitlement">
                    <thead class="thead-light">
                        <tr>
                            <th scope="col" class="p-1 pl-4 font-weight-bold paragraph-reduced" width="30%" v-html="tableHeaders.firstCol"></th>
                            <th scope="col" class="p-1 pl-4 font-weight-bold paragraph-reduced" v-html="tableHeaders.secondCol"></th>
                            <th scope="col" class="p-1 pl-4 font-weight-bold paragraph-reduced" v-html="tableHeaders.thirdCol" v-if="!restrictEntitlementTable"></th>
                            <th scope="col" class="p-1 pl-4 font-weight-bold paragraph-reduced" v-html="tableHeaders.fourthCol"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(entitlement, i) in entitlementDetails" :key="i" v-if="entitlement.isDisplay">
                            <td class="p-1 pl-4">{{ entitlement.entitlementGroupName }}</td>
                            <td class="p-1 pl-4">{{ printEntitlmentCount(entitlement.entitled) }}</td>
                            <td class="p-1 pl-4" v-if="!restrictEntitlementTable">{{ printEntitlmentCount(entitlement.used) }}</td>
                            <td class="p-1 pl-4">{{ printEntitlmentCount(entitlement.remaining) }}</td>
                        </tr>
                    </tbody>
                </table>
                <p class="mt-3 mb-0" v-if="selectedServiceGroupNameCondensed == 'hardwastecollection' && totalEntitlements === 0">{{ TEXTS.render(`ENTITLEMENT_TABLE_FOOTER`, (selectedServiceGroupNameCondensed == 'hardwastecollection' && totalEntitlements === 0 ? `noentitlements` : `default`), null, {skipCasing : true}) }}</p>
            </div>
            <button class="btn-link" @click.prevent="bookingHistory" @keydown="bookingHistoryKeyEvent">
                {{ TEXTS.render(`ENTITLEMENT_TABLE_BTN_VIEW_HISTORY`) }}
            </button>
        </div>
    </div>
</template>

<script>
    import EntitlementDetail from '../../../../common/utils/EntitlementDetail';
    import EntitlementGroup from '../../../../common/utils/EntitlementGroup';
    import EntitlementSummary from '../../../../common/utils/EntitlementSummary';
    import RetryWorker from '../../../../common/utils/RetryWorker';
    import DateFormattable from '../../../../common/utils/DateFormattable';
    import BookingStateManager from '../../../../common/utils/BookingStateManager';
    import ConfirmationModal from '../../../../common/components/ConfirmationModal';
    import Texts from '../../../../common/utils/Texts'
    export default {
        components: {
            ConfirmationModal,
        },
        data() {
            return {
                selectedServiceId: null,
                entitlementsfromAPI: [],
                periodDate: [],
                selectedServiceGroupId: null,
                entitlementSummary : null,
                entitlementDisplay : false,
                totalEntitlements : 0,
            }
        },
        computed: {
            TEXTS(){
                return Texts
            },
            bookingState : function(){
                return this.$store.getters.GET_BOOKING_STATE
            },
            selectedServiceWording : function(){
                var selectedService = this.$store.getters.GET_BOOKING_STATE.selectedService;
                return selectedService ? selectedService.wording : null;
            },
            selectedServiceGroupName : function(){
                var selectedServiceGroup = this.$store.getters.GET_BOOKING_STATE.selectedServiceGroup;
                return selectedServiceGroup != null ? selectedServiceGroup.group_name : null;
            },
            selectedServiceGroupWording : function(){
                var selectedServiceGroup = this.$store.getters.GET_BOOKING_STATE.selectedServiceGroup;
                return selectedServiceGroup != null ? selectedServiceGroup.wording : null;
            },
            servicesOfServiceGroup : function(){
                return this.$store.getters.GET_BOOKING_STATE.servicesOfServiceGroup;
            },
            entitlementGroupsOfServices : function(){
                var entitlementGroups = this.$store.getters.GET_ENTITLEMENT_GROUP.list;
                if(!entitlementGroups || !this.servicesOfServiceGroup){     
                    return null;
                }
                return entitlementGroups.filter(entitlementGroup =>{
                    entitlementGroup = new EntitlementGroup(entitlementGroup);
                    return entitlementGroup.isFoundInServiceList(this.servicesOfServiceGroup);
                })
            },
            selectedServiceGroupNameCondensed(){ // Duplicated from SelectServiceButton
                var selectedServiceGroup = this.$store.getters.GET_BOOKING_STATE.selectedServiceGroup;
                if(selectedServiceGroup && selectedServiceGroup.group_name){
                    let trimmedName = selectedServiceGroup.group_name.toLowerCase().trim().replace(/\ /g, '')
                    if(trimmedName.indexOf('hardwastecollection') > -1){
                        return 'hardwastecollection'
                    }
                    else if(trimmedName.indexOf('missedcollection') > -1){
                        return 'missedcollection'
                    }
                    else if(trimmedName.indexOf('binrepair') > -1 || trimmedName.indexOf('binmaintenance') > -1){
                        return 'binmaintenance'
                    }
                }
            },
            serverDateString : function(){
                return this.$store.getters.GET_SERVER_DATE.payload;
            },
            availableBookingDatesOfAddress : function(){
                return this.$store.getters.GET_AVAILABLE_BOOKING_DATES_OF_ADDRESS.list;
            },
            entitlementDetails: function() {
                // Step 2. Get the entitlement details from the API via store get
                var entitlementDetails = this.$store.getters.GET_ADDRESS_ENTITLEMENT.list;
                var serverDateString = this.serverDateString
                var bookingState = this.bookingState;
                if(!entitlementDetails
                    || !bookingState 
                    || !this.entitlementGroupsOfServices 
                    || !this.availableBookingDatesOfAddress
                    || !serverDateString
                ){
                    return;
                }
                for (let i = 0; i < entitlementDetails.length; i++) {
                    entitlementDetails[i] = new EntitlementDetail(entitlementDetails[i], this.restrictEntitlementTable);
                }
                var entitlementSummary = new EntitlementSummary(entitlementDetails);

                // Cache selected service group id for error purposes
                if(bookingState.selectedServiceGroup){
                    if(!this.selectedServiceGroupId || this.selectedServiceGroupId != bookingState.selectedServiceGroup.service_group_id){
                        this.selectedServiceGroupId = bookingState.selectedServiceGroup.service_group_id
                        localStorage.hasAlreadyReportedErr = false
                    }
                }

                entitlementSummary.filterByEntitlementGroups(this.entitlementGroupsOfServices);
                entitlementSummary.calculateCurrentAndNextPeriod(serverDateString);
                entitlementSummary.calculateEffectiveEntitlements(this.availableBookingDatesOfAddress);
                entitlementSummary.entitlementSettings = this.entitlementGroupsOfServices;
                
                // Construct Summary for other components
                if(!bookingState.entitlementSummary || 
                    JSON.stringify(bookingState.entitlementSummary) != JSON.stringify(entitlementSummary)){
                    bookingState.entitlementSummary = entitlementSummary;
                    this.$store.dispatch("setBookingState", bookingState);
                    this.$store.dispatch('setActiveMultipleServiceEntitlementSummaries', { entitlementSummary });
                }

                //Prints current period date and format it using Moment JS
                // this.periodDate = this.$moment(entitlementSummary.currentPeriod.startDate).format('LL') + ' to ' + this.$moment(entitlementSummary.currentPeriod.endDate).format('LL');
                this.periodDate = new DateFormattable(entitlementSummary.currentPeriod.startDate).formatDdMonYyyy() + ' to ' + new DateFormattable(entitlementSummary.currentPeriod.endDate).formatDdMonYyyy();
                this.entitlementSummary = entitlementSummary
                this.totalEntitlements = entitlementSummary.totalEntitlements;

                return entitlementSummary.currentPeriod.entitlementDetails; // Return the Current Period
            },
            serviceGroupSet() {
                return this.$store.getters.GET_ACTIVE_SERVICE_GROUP;
            },
            entitlementTableHeader(){
                const tableHeader = this.selectedServiceGroupWording ? this.selectedServiceGroupWording.entitlement_table_label : null
                return tableHeader || Texts.render(`ENTITLEMENT_TABLE_HEADER`, null, {selectedServiceGroupName : this.selectedServiceGroupName}) 
            },
            siteWordings() {
                return this.$store.getters['GET_SITE_WORDINGS']; 
            },
            tableHeaders(){
                const firstCol = this.siteWordings ? this.siteWordings.entitlement_h1 : null,
                secondCol = this.siteWordings ? this.siteWordings.entitlement_h2 : null,
                thirdCol = this.siteWordings ? this.siteWordings.entitlement_h3 : null,
                fourthCol = this.siteWordings ? this.siteWordings.entitlement_h4 : null

                return {
                    firstCol : firstCol || Texts.render(`ENTITLEMENT_TABLE_FIRST_COL`), 
                    secondCol : secondCol || Texts.render(`ENTITLEMENT_TABLE_SECOND_COL`), 
                    thirdCol : thirdCol || Texts.render(`ENTITLEMENT_TABLE_THIRD_COL`), 
                    fourthCol : fourthCol || Texts.render(`ENTITLEMENT_TABLE_FOURTH_COL`) 
                }  
            },
            restrictEntitlementTable() {
                var setting = this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_BOOKING_SETTING;
                var personalInfo = this.$store.getters.GET_PERSONAL_INFO;
                
                return setting && !!setting.is_restrict_entitlement_table && personalInfo && personalInfo.type == 'resident';
            },
        },
        mounted() {

            localStorage.hasAlreadyReportedErr = false

            // this.$store.dispatch('getSiteWordingsSettings');

            // Step 1. Dispatch from the component that will use the data
            this.$store.dispatch('getEntitlementGroup') ;

            // Dispatch AU getserver date and pass resident id.
            this.$store.dispatch('getServerDate');

            // Retry for getEntitlements Of Address
            this.getEntitlementsOfAddress()
        },
        methods: {
            bookingHistory() {
                var bookingManager = new BookingStateManager();
                bookingManager.upsertAddressMap(this.bookingState.activeAddress)
                this.$router.push({ path: 'history', query: { id: this.bookingState.activeAddress.id }})
            },
            bookingHistoryKeyEvent(event){
                if (event.keyCode == 32 || event.keyCode == 13) {
                    event.preventDefault();
                    this.bookingHistory(event)
                }
            },
            printEntitlmentCount(count){
                try{
                    count = parseInt(count);
                    if(count >= 999){ 
                        return "Unlimited";
                    }
                }catch(err){

                };
                    
                return count;
            },
            getEntitlementsOfAddress(){
                var self = this;
                new RetryWorker(10, 200, 
                    function(){
                        return new Promise((resolve, reject) => {
                            var bookingState = self.bookingState;
                            if(bookingState.activeAddress){
                                self.$store.dispatch('getAddressEntitlementV3', bookingState.activeAddress.id)
                            }
                            else{
                                resolve(false);
                            }
                        });
                    }).doWork();
            },
            resetForm(){
                this.getEntitlementsOfAddress()
            },
        },
        watch: {
            entitlementDetails(val) {
                //RP-1193-Hide-entire-entitlement-section
                //check Entitlement is Display or not 
                if(val) {
                    val.forEach(item => {
                        if(item.isDisplay) {
                            this.entitlementDisplay = true;
                            return;
                        }
                    })
                }
            }
        }
    }
</script>
